"use client";
import React, { useState } from "react";

const ContactMap: React.FC = () => {

  return (
    <iframe className="contactmap" src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3671.323385893765!2d72.52479679999999!3d23.0486028!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x395e8488d0391cb5%3A0xc7d642a0953a6d36!2sWebile%20Technologies!5e0!3m2!1sen!2sin!4v1738562584426!5m2!1sen!2sin" width="100%" height="450" style={{border:0}} allowFullScreen loading="lazy" referrerPolicy="no-referrer-when-downgrade"></iframe>
  )
};

export default ContactMap;
